/* Detailing1 — GetSale-Mengenkarten an unser Design anpassen (2026-10-21, Jasper; 2026-11-03 wie der B2B-Mengenvorteil)
 * Geladen von snippets/d1-getsale.liquid (nur Produktseiten, nicht fuer Firmenkonten).
 * Die App rendert ihre Karten selbst und schreibt einige Texte fest ins Skript (nicht einstellbar, weder per Metafeld noch
 * per Uebersetzung). Dieses Skript bearbeitet die fertigen Karten nach:
 *  - Preise „16.90 EUR“ -> Shop-Format „16,90€“ (nur in der Anzeigewaehrung)
 *  - Karte zeigt den Stueckpreis „9,79€ / Stück“ statt Gesamtpreis + Streichpreis (wie .d1-vp__unit)
 *  - Prozent-Pille gegen die UVP der Variante (compare_at_price), sonst gegen den Stueckpreis der ersten Stufe —
 *    gleiche Rechnung wie snippets/d1-pdp-mengenvorteil; „Best value“ -> „Bester Preis“
 *  - rechts neben der Ueberschrift: Summe der gewaehlten Stufe + UVP-Summe (wie .d1-vp__sum)
 *  - Warenkorb-Button zeigt den Rabattpreis der gewaehlten Stufe (atc-price.js rechnet Stueckpreis x Menge ohne Rabatt)
 *  - Mengenfeld bleibt sichtbar (die App blendet es aus): Karte waehlt die Stufe zur eingegebenen Menge, Klick auf eine
 *    Karte setzt die Menge, in den Warenkorb geht die Menge aus dem Feld (Jasper 2026-11-03, wie beim Mengenvorteil)
 *  - Preisblock (Stueckpreis, Grundpreis, Rabatt-Badge) zeigt den Preis der gewaehlten Stufe wie beim Mengenvorteil;
 *    der MwSt.-Betrag folgt von selbst (d1-tax-shipping.js liest .price__current)
 * Ohne GetSale-Karten auf der Seite tut das Skript nichts. Aussehen: Abschnitt 14 in assets/custom.css. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('d1-gs-config');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = C.t || {};

  function group(n, dec, ts, ds) {
    var p = n.toFixed(dec).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
    return p.join(ds);
  }
  /* Shop-Geldformat wie in assets/d1-tax-shipping.js */
  function money(cents) {
    var v = cents / 100, fmt = C.money || '{{amount_with_comma_separator}}€';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount', s;
    switch (key) {
      case 'amount_no_decimals': s = group(v, 0, ',', '.'); break;
      case 'amount_with_comma_separator': s = group(v, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': s = group(v, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': s = group(v, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': s = group(v, 0, ' ', ','); break;
      case 'amount_with_space_separator': s = group(v, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': s = group(v, 2, ' ', '.'); break;
      default: s = group(v, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, s).replace(/<[^>]+>/g, '').trim();
  }

  /* App-Format: "16.90 EUR" bzw. "$16.90" (ohne Shopify.formatMoney im Theme) */
  var APP_MONEY = /^\s*\$?(\d+(?:\.\d{1,2})?)\s*([A-Z]{3})?\s*$/;
  function fixPrice(el) {
    if (!el || el.dataset.d1gs === el.textContent) return;
    var m = APP_MONEY.exec(el.textContent);
    if (m && (!m[2] || m[2] === C.cur)) {
      var cents = Math.round(parseFloat(m[1]) * 100);
      el.textContent = money(cents);
      el.dataset.d1gsCents = String(cents);
    }
    el.dataset.d1gs = el.textContent;
  }

  function setText(el, t) { if (el.textContent !== t) el.textContent = t; }

  /* Mindestmenge der Karte aus „Ab 2 Stück“ / „Kaufe 2“ */
  function qtyOf(card) {
    var q = card.querySelector('.dm-qty-card-quantity'), m = q && /\d+/.exec(q.textContent);
    return m ? parseInt(m[0], 10) : 0;
  }

  function cmpOf(widget) {
    var scope = widget.closest('.js-product');
    var id = scope && scope.querySelector('.js-product-form-main [name="id"]');
    return (id && C.cmp && C.cmp[id.value]) || 0;
  }

  /* Prozent der Stufe aus der App-Regel (window.DISCOUNT_MANAGER, Widget-ID dm-qty-<id> = Regel qty-discount-<id>);
   * null, wenn die Regel nicht prozentual ist oder fehlt */
  function tierPct(widget, q) {
    var rules = window.DISCOUNT_MANAGER && DISCOUNT_MANAGER.qtyBreaks && DISCOUNT_MANAGER.qtyBreaks.discountRules;
    var r = rules && widget && rules['qty-discount-' + String(widget.id || '').replace(/^dm-qty-/, '')];
    if (!r || r.valueType !== 'percentage' || !r.discountTiers) return null;
    var pct = null, bq = 0;
    r.discountTiers.forEach(function (t) {
      var tq = Number(t.discountQuantity);
      if (tq <= q && tq >= bq) { bq = tq; pct = Number(t.discountValue) || 0; }
    });
    return pct;
  }

  /* Stueckpreis der Karte in Cent (null, wenn der App-Preis nicht in der Anzeigewaehrung umgeformt werden konnte).
   * Wie im Warenkorb: GetSale rundet den Rabatt je Stueck ab (2 % auf 9,99€ = 0,19€ -> 9,80€; die App-Karte selbst zeigt
   * 19,58€ fuer 2 Stueck, der Warenkorb 19,60€ — geprueft 2026-11-03). */
  function unitOf(card) {
    var disc = card.querySelector('.dm-qty-card-price-discounted'), orig = card.querySelector('.dm-qty-card-price-original');
    var q = qtyOf(card), d = disc && parseInt(disc.dataset.d1gsCents, 10);
    if (!(d > 0) || !q) return null;
    var o = orig && !orig.hidden && parseInt(orig.dataset.d1gsCents, 10);
    var list = Math.round((o > 0 ? o : d) / q);
    var pct = tierPct(card.closest('.dm-qty-widget'), q);
    if (pct === null) return Math.round(d / q);
    return list - Math.floor(list * pct / 100 + 1e-9);
  }

  function fixCard(card, ref) {
    card.querySelectorAll('.dm-qty-card-price-discounted, .dm-qty-card-price-original').forEach(fixPrice);
    var unit = unitOf(card);
    var badge = card.querySelector('.dm-qty-card-badge');
    if (badge) {
      var t = '';
      if (unit !== null && ref > 0) {
        var pct = Math.round((1 - unit / ref) * 100);
        if (pct > 0) t = '−' + pct + ' %';
      } else {
        /* Fallback ohne umgerechneten Preis: Staffelrabatt der App („15% off“), „Standard price“ ausblenden */
        var m = /^(\d+(?:[.,]\d+)?)\s*%\s*off$/i.exec(badge.textContent.trim());
        t = m ? '−' + m[1].replace('.', ',') + ' %' : (/^−/.test(badge.textContent) ? badge.textContent : '');
      }
      setText(badge, t);
      if (badge.hidden !== !t) badge.hidden = !t;
    }
    var best = card.querySelector('.dm-qty-card-best-value');
    if (best && T.best) setText(best, T.best);

    var u = card.querySelector('.d1-gs-unit');
    if (unit !== null) {
      if (!u) {
        u = document.createElement('span');
        u.className = 'd1-gs-unit';
        u.innerHTML = '<span class="d1-gs-unit__amt"></span> <span class="d1-gs-unit__per"></span>';
        card.appendChild(u);
      }
      setText(u.firstChild, money(unit));
      setText(u.lastChild, T.per || '');
      if (!card.classList.contains('d1-gs-card--unit')) card.classList.add('d1-gs-card--unit');
    } else if (u) {
      u.remove();
      card.classList.remove('d1-gs-card--unit');
    }

    var q = card.querySelector('.dm-qty-card-quantity');
    var parts = [q ? q.textContent.trim() : ''];
    if (u) parts.push(u.textContent.trim());
    if (badge && !badge.hidden && badge.textContent.trim()) parts.push(badge.textContent.trim());
    if (card.classList.contains('dm-qty-card--best-value') && T.best) parts.push(T.best);
    var label = parts.filter(Boolean).join(', ');
    if (label && card.getAttribute('aria-label') !== label) card.setAttribute('aria-label', label);
  }

  /* Mengenfeld des Themes. Die App nimmt ihm den name (data-dm-qty-cards-orig-name) und schreibt die Menge in ein
   * eigenes verstecktes Feld (.dm-qty-cards-qty-bridge). */
  function qtyField(widget) {
    var scope = widget.closest('.js-product');
    return scope && scope.querySelector('.js-product-form-main input[data-dm-qty-cards-orig-name]');
  }
  function fieldQty(widget) {
    var f = qtyField(widget), n = f ? parseInt(f.value, 10) : NaN;
    return n > 0 ? n : 0;
  }

  /* Betrag fuer q Stueck in der gewaehlten Stufe: Stueckpreis der Stufe x q (wie der Warenkorb) */
  function totalFor(sel, q) {
    var u = unitOf(sel), cq = qtyOf(sel);
    return u === null ? null : u * (q || cq);
  }

  /* Kopfzeile wie .d1-vp__sum: Summe der gewaehlten Stufe, daneben die UVP-Summe. Steht als Geschwister hinter der
   * App-Ueberschrift (die App-Knoten bleiben unangetastet), Anordnung per CSS-Raster. */
  function fixSum(widget, cmp) {
    var head = widget.querySelector('.dm-qty-heading');
    var sel = widget.querySelector('.dm-qty-card--selected');
    var disc = sel && sel.querySelector('.dm-qty-card-price-discounted');
    var sum = widget.querySelector('.d1-gs-sum');
    if (!head || !disc || !disc.dataset.d1gsCents) { if (sum) sum.remove(); return; }
    if (!sum) {
      sum = document.createElement('span');
      sum.className = 'd1-gs-sum';
      sum.innerHTML = '<strong class="d1-gs-sum__total"></strong><s class="d1-gs-sum__uvp"></s>';
    }
    if (sum.previousElementSibling !== head) head.insertAdjacentElement('afterend', sum);
    var q = fieldQty(widget) || qtyOf(sel), total = totalFor(sel, q), uvp = cmp * q;
    if (total === null) { sum.remove(); return; }
    setText(sum.firstChild, money(total));
    setText(sum.lastChild, uvp > total ? money(uvp) : '');
  }

  /* Betrag aus einem Theme-Preis („9,99€“, „1.234,50 €“) in Cent */
  function centsOf(t) {
    var m = /(\d{1,3}(?:[.,\u00a0 ]\d{3})+|\d+)[.,](\d{2})(?!\d)/.exec(t || '');
    return m ? parseInt(m[1].replace(/\D/g, ''), 10) * 100 + parseInt(m[2], 10) : null;
  }

  /* Preisblock wie snippets/d1-pdp-mengenvorteil (Jasper 2026-11-03): Stueckpreis der gewaehlten Stufe, Grundpreis
   * linear mitskaliert, Rabatt-Badge („9% Rabatt“) gegen die UVP. Unsere Werte merken wir in data-d1gs; steht dort etwas
   * anderes (Theme hat neu gerendert, z. B. Variantenwechsel), ist der aktuelle Text der neue Ausgangswert. */
  function fixPriceBlock(widget, cmp, base) {
    var scope = widget.closest('.js-product');
    var sel = widget.querySelector('.dm-qty-card--selected');
    var unit = sel ? unitOf(sel) : null;
    if (!scope || unit === null || base === null) return;
    var price = scope.querySelector('.product-info__price .price__default .price__current:not([data-d1net-el])');
    if (price) {
      var want = money(unit);
      if (price.textContent.trim() !== want) price.textContent = want;
      price.dataset.d1gs = want;
    }
    var up = scope.querySelector('.product-info__price .unit-price__price');
    if (up) {
      if (up.dataset.d1gs !== up.textContent || !up.dataset.d1gsBase) up.dataset.d1gsBase = String(centsOf(up.textContent) || '');
      var b = parseInt(up.dataset.d1gsBase, 10);
      if (b > 0) {
        var u = money(Math.round(b * unit / base));
        if (up.textContent !== u) up.textContent = u;
        up.dataset.d1gs = u;
      }
    }
    var badge = scope.querySelector('.product-label--sale');
    if (badge && cmp > unit) {
      var pct = String(Math.round((1 - unit / cmp) * 100));
      var w = document.createTreeWalker(badge, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        if (/\d/.test(n.nodeValue)) {
          var v = n.nodeValue.replace(/\d+/, pct);
          if (v !== n.nodeValue) n.nodeValue = v;
          break;
        }
      }
    }
  }

  /* Warenkorb-Button: Rabattpreis der gewaehlten Stufe statt Stueckpreis x Menge. Nur bei einer Stufe mit Rabatt und nur,
   * wenn der Preis in der Anzeigewaehrung umformatiert wurde — sonst bleibt der Wert von atc-price.js stehen. */
  function fixAtc(widget) {
    var scope = widget.closest('.js-product');
    var amount = scope && scope.querySelector('.js-product-form-main .js-atc-price');
    var sel = widget.querySelector('.dm-qty-card--selected');
    if (!amount || !sel || amount.hidden) return;
    var orig = sel.querySelector('.dm-qty-card-price-original');
    var disc = sel.querySelector('.dm-qty-card-price-discounted');
    if (!disc || !disc.dataset.d1gsCents || !orig || orig.hidden || !orig.textContent.trim()) return;
    var total = totalFor(sel, fieldQty(widget));
    var want = total === null ? disc.textContent.trim() : money(total);
    if (amount.textContent.trim() !== want) amount.textContent = want;
  }

  /* Mengenfeld einblenden (App: Klasse dm-qty-cards-qty-hidden + Inline display:none !important) */
  function showQty(widget) {
    var scope = widget.closest('.js-product');
    if (!scope) return;
    scope.querySelectorAll('.js-product-form-main .dm-qty-cards-qty-hidden').forEach(function (el) {
      el.classList.remove('dm-qty-cards-qty-hidden');
      el.style.removeProperty('display');
    });
  }

  /* Karte zur Menge im Feld waehlen. Ein Klick auf die Karte setzt das Feld auf die Kartenmenge — danach stellen wir die
   * eingegebene Menge wieder her. */
  /* Verstecktes App-Feld (.dm-qty-cards-qty-bridge, traegt name="quantity") auf die Feldmenge. Die App schreibt dort beim
   * Absenden die Kartenmenge hinein (Capture-Listener am Formular); Formular-Abfang anderer Apps (Candy Rack) liest es. */
  function setBridge(widget) {
    var scope = widget.closest('.js-product'), q = fieldQty(widget);
    if (!scope || !q) return;
    /* je Produktformular eines (Hauptformular, Ratenzahlungs-Formular) */
    scope.querySelectorAll('form input.dm-qty-cards-qty-bridge').forEach(function (b) {
      if (b.value !== String(q)) { b.value = String(q); b.setAttribute('value', String(q)); }
    });
    window.__dmQtyCardsSelectedQty = q;
  }
  /* Die App schreibt beim Klick auf „In den Warenkorb“ die Kartenmenge erneut in ihr Feld .dm-qty-cards-qty-bridge und in
   * unser Mengenfeld (ueber den value-Setter von HTMLInputElement), danach liest Candy Rack das Formular. Deshalb:
   *  - .dm-qty-cards-qty-bridge traegt immer die Menge aus dem sichtbaren Mengenfeld,
   *  - waehrend des Klicks/Absendens (guardQty) bleibt auch das Mengenfeld auf der eingegebenen Menge.
   * Alle anderen Eingabefelder bleiben unberuehrt. */
  var guardQty = 0;
  function guard(e) {
    /* nur Warenkorb-Button bzw. Absenden des Hauptformulars — nicht +/− oder andere Klicks im Formular */
    var t = e.type === 'submit'
      ? (e.target && e.target.matches && e.target.matches('form.js-product-form-main') ? e.target : null)
      : (e.target && e.target.closest && e.target.closest('.js-product-form-main [name="add"], .js-product-form-main button[type="submit"]'));
    var scope = t && t.closest('.js-product');
    var w = scope && scope.querySelector('.dm-qty-widget.dm-qty-cards');
    if (!w) return;
    guardQty = fieldQty(w);
    setBridge(w);
    setTimeout(function () { guardQty = 0; }, 0);
  }
  window.addEventListener('click', guard, true);
  window.addEventListener('submit', guard, true);
  (function () {
    var P = window.HTMLInputElement && HTMLInputElement.prototype;
    var D = P && Object.getOwnPropertyDescriptor(P, 'value');
    if (!D || !D.set || !D.configurable) return;
    try {
      Object.defineProperty(P, 'value', {
        configurable: true, enumerable: D.enumerable, get: D.get,
        set: function (v) {
          if (this.classList && this.classList.contains('dm-qty-cards-qty-bridge')) {
            var scope = this.closest && this.closest('.js-product');
            var w = scope && scope.querySelector('.dm-qty-widget.dm-qty-cards'), q = guardQty || (w ? fieldQty(w) : 0);
            if (q) v = String(q);
          } else if (guardQty && this.dataset && this.dataset.dmQtyCardsOrigName) {
            v = String(guardQty);
          }
          D.set.call(this, v);
        }
      });
    } catch (e) {}
  })();

  var syncing = false;
  function cardFor(widget, q) {
    var best = null, bq = 0;
    widget.querySelectorAll('.dm-qty-card').forEach(function (c) {
      var cq = qtyOf(c);
      if (cq && cq <= q && cq >= bq) { best = c; bq = cq; }
    });
    return best;
  }
  function setField(f, q) {
    var d = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    d && d.set ? d.set.call(f, String(q)) : (f.value = String(q));
    f.dispatchEvent(new Event('input', { bubbles: true }));
    f.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function syncCard(widget) {
    if (syncing) return;
    var f = qtyField(widget), q = fieldQty(widget);
    if (!f || !q) return;
    setBridge(widget);
    var c = cardFor(widget, q);
    if (!c || c.classList.contains('dm-qty-card--selected')) return;
    syncing = true;
    try {
      c.click();
      if (fieldQty(widget) !== q) setField(f, q);
      setBridge(widget);
    } finally { syncing = false; }
  }

  /* Menge fuer den Warenkorb: die App fragt window.__dmQtyCardsGetQuantity (fetch-/XHR-/Formular-Abfang). Wir legen
   * die Feldmenge darueber; ohne Feld bleibt die Kartenmenge der App. Laeuft vor dem App-Skript (beide defer, wir im <head>). */
  (function () {
    var appFn = window.__dmQtyCardsGetQuantity;
    try {
      Object.defineProperty(window, '__dmQtyCardsGetQuantity', {
        configurable: true,
        get: function () {
          return function () {
            var w = document.querySelector('.dm-qty-widget.dm-qty-cards'), q = w ? fieldQty(w) : 0;
            return q || (typeof appFn === 'function' ? appFn() : NaN);
          };
        },
        set: function (fn) { appFn = fn; }
      });
    } catch (e) {}
  })();

  function run() {
    document.querySelectorAll('.dm-qty-widget.dm-qty-cards').forEach(function (w) {
      var list = w.querySelector('.dm-qty-cards-list');
      if (list && T.tiers && list.getAttribute('aria-label') !== T.tiers) list.setAttribute('aria-label', T.tiers);
      showQty(w);
      syncCard(w);
      var cards = w.querySelectorAll('.dm-qty-card'), cmp = cmpOf(w);
      cards.forEach(function (c) { c.querySelectorAll('.dm-qty-card-price-discounted').forEach(fixPrice); });
      /* Bezug wie im Mengenvorteil: UVP, wenn sie ueber dem Stueckpreis der ersten Stufe liegt, sonst dieser */
      var base = cards.length ? unitOf(cards[0]) : null, ref = base === null ? 0 : (cmp > base ? cmp : base);
      cards.forEach(function (c) { fixCard(c, ref); });
      fixSum(w, cmp);
      fixPriceBlock(w, cmp, base);
      fixAtc(w);
    });
  }

  /* Als Microtask, nicht per setTimeout: Theme (atc-price.js, Preisblock) schreibt bei Mengen-Events den Normalpreis
   * zurueck; die Korrektur muss vor dem naechsten Zeichnen laufen, sonst springt der Preis kurz (Jasper 2026-11-03).
   * run() ist idempotent, eigene Schreibzugriffe loesen hoechstens einen weiteren Lauf ohne Aenderung aus. */
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    Promise.resolve().then(function () { pending = false; run(); });
  }

  function relevant(n) {
    var e = n && (n.nodeType === 1 ? n : n.parentElement);
    return !!(e && e.closest && (e.closest('.dm-qty-widget') || e.closest('.js-atc-price') || e.closest('.product-info__price') || (e.classList && e.classList.contains('dm-qty-cards-qty-hidden')) ||
      (e.querySelector && e.querySelector('.dm-qty-widget'))));
  }

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (relevant(muts[i].target)) { schedule(); return; }
      var a = muts[i].addedNodes;
      for (var j = 0; j < a.length; j++) if (relevant(a[j])) { schedule(); return; }
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden'] });

  /* Variantenwechsel: UVP und Summe haengen an der gewaehlten Variante */
  document.addEventListener('on:variant:change', schedule);
  document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') schedule(); });
  /* Mengenfeld (+/−, Eingabe): Stufe und Betraege nachziehen */
  ['input', 'change'].forEach(function (t) {
    document.addEventListener(t, function (e) {
      if (!syncing && e.target && e.target.matches && e.target.matches('input[data-dm-qty-cards-orig-name]')) schedule();
    });
  });

  run();
  window.d1GetSale = { run: run };
})();
